export enum doctype {
    fitting,
    closure,
    pig
}